export const UsagekpiBundle = {
  usage: { ko: "사용량", en: "Usage", es: "Consumo" },
  leakAmount: { ko: "예상 손실량", en: "Estimated Loss Volume", es: "Volumen de pérdida estimada" },
  leakRate: { ko: "손실률", en: "Loss Rate", es: "Tasa de pérdida" },
  leakCost: { ko: "손실 예상 요금", en: "Estimated Loss Cost", es: "Costo de pérdida estimada" },
  leakStartTime: { ko: "손실 시작 시점", en: "Loss Start Time", es: "Hora de inicio de pérdida" },
  leakType: { ko: "손실 유형", en: "Loss Type", es: "Tipo de pérdida" },
  time: { ko: "시", en: "H", es: "H" }
}
